import DialogResponsive from 'my-elements/DialogResponsive';

import CoursePurchaseCheckoutConfirmation from './CoursePurchaseCheckoutConfirmation';
import CoursePurchaseCheckoutHeader from './CoursePurchaseCheckoutHeader';
import CoursePurchaseCheckoutPayment from './CoursePurchaseCheckoutPayment';

const rootCss = ({ breakpoints, palette, spacing }) => ({
  '.CPC-content': {
    padding: spacing(2, 8),
    background: palette.background.default,
    [breakpoints.down('sm')]: { padding: spacing(2) },
  },
});

export default function CoursePurchaseCheckout({
  activeStep,
  confirming,
  course,
  currentUser,
  defaultDiscountCode,
  defaultPlan,
  discountCode,
  noDialog,
  onChangeStep,
  onClose,
  onPaymentSuccess,
  open,
  paymentIntent,
  paymentMethod,
  product,
  purchaseError,
  subscription,
  userCourse,
}) {
  const breadcrumbs = ['Payment', 'Confirmation'];
  return noDialog ? renderActiveStep() : (
      <DialogResponsive css={rootCss} fullWidth open={open}>
        <CoursePurchaseCheckoutHeader
          activeStep={activeStep}
          breadcrumbs={breadcrumbs}
          loading={confirming}
          onChangeStep={onChangeStep}
          onClose={onClose}
        />
        <div className="CPC-content">{renderActiveStep()}</div>
      </DialogResponsive>
    );

  function renderActiveStep() {
    switch (activeStep) {
      case 0:
        return (
          <CoursePurchaseCheckoutPayment
            course={course}
            currentUser={currentUser}
            defaultDiscountCode={defaultDiscountCode}
            defaultPlan={defaultPlan}
            discountCode={discountCode}
            loading={confirming}
            noDialog={noDialog}
            onClose={onClose}
            onPaymentSuccess={onPaymentSuccess}
            paymentIntent={paymentIntent}
            paymentMethod={paymentMethod}
            product={product}
            purchaseError={purchaseError}
            subscription={subscription}
            userCourse={userCourse}
          />
        );
      case 1:
        return (
          <div>
            <CoursePurchaseCheckoutConfirmation course={course} noDialog={noDialog} onClose={onClose} />
          </div>
        );
    }
  }
}
